import React from "react";
import { cashConverter } from "../../../../utils";
import { Table } from "antd";

function PathwayData() {
  // Static data based on the image
  const data = [
    {
      id: 1,
      investmentType: "Tier 1 Expansion",
      newAcres: 25000,
      optimised: 15000,
      govt: 35,
      private: 18.5,
    },
    {
      id: 2,
      investmentType: "Tier 2 Expansion",
      newAcres: 20000,
      optimised: 15000,
      govt: 22,
      private: 10,
    },
  ];

  const columns = [
    {
      title: "Investment Type",
      dataIndex: "investmentType",
      sorter: (a, b) => a.investmentType.localeCompare(b.investmentType),
    },
    {
      title: "New Acres",
      dataIndex: "newAcres",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.newAcres - b.newAcres,
    },
    {
      title: "Optimised",
      dataIndex: "optimised",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.optimised - b.optimised,
    },
    {
      title: "Govt. (Bn)",
      dataIndex: "govt",
      render: (item) => {
        return <div>Kes. {item}</div>;
      },
      sorter: (a, b) => a.govt - b.govt,
    },
    {
      title: "Private (Bn)",
      dataIndex: "private",
      render: (item) => {
        return <div>Kes. {item}</div>;
      },
      sorter: (a, b) => a.private - b.private,
    },
  ];

  // Calculate totals
  const totalBudget = 85.5;
  const costPerAcre = 1337500;

  // Funding ratio data with colors
  const fundingData = [
    { label: "Govt", percentage: 60, color: "#4CAF50" },
    { label: "Private", percentage: 40, color: "#2196F3" },
  ];

  return (
    <div className="lg:mt-[2.5rem] mt-[1rem] lg:p-[2.5rem] p-3 rounded-[1rem] bg-white">
      <div className="text-[#1A1A1A] font-sora text-[1.25rem] font-[600] leading-[1.5rem]">
        Pathway Data
      </div>

      <Table
        rowSelection={false}
        className="mt-[1.25rem] w-full"
        scroll={{
          x: "auto",
        }}
        rowKey={(record) => record?.id}
        columns={columns}
        dataSource={data}
        pagination={false}
        summary={() => (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={2}>
                <div className="mt-[2rem] space-y-[1rem]">
                  {[
                    { label: "Total Budget:", value: `KSh ${totalBudget}bn` },
                    {
                      label: "Cost per Acre (Tier 1 Expansion):",
                      value: `KSh ${cashConverter(costPerAcre)}`,
                    },
                  ]?.map((item, index) => (
                    <div
                      key={index}
                      className="flex justify-between items-center"
                    >
                      <div className="text-[#666642424266] font-sora text-[0.875rem]  font-[400]">
                        {item?.label}
                      </div>
                      <div className="text-[#424242] font-sora text-[0.875rem] font-[600] leading-[1.5rem]">
                        {item?.value}
                      </div>
                    </div>
                  ))}

                  {/* Funding Ratio */}
                  <div className="flex justify-between items-start">
                    <div className="text-[#424242] font-sora text-[0.875rem] font-[400]">
                      Funding Ratio:
                    </div>
                    <div className="flex flex-col items-end gap-[0.5rem]">
                      <div className="flex gap-[1rem] text-[0.75rem] font-sora">
                        {fundingData?.map((item, index) => (
                          <span key={index} style={{ color: item?.color }}>
                            {item?.label} {item?.percentage}%
                          </span>
                        ))}
                      </div>
                      <div className="flex w-[15rem] h-[0.375rem] rounded-full overflow-hidden">
                        {fundingData?.map((item, index) => (
                          <div
                            key={index}
                            className="h-full"
                            style={{
                              width: `${item?.percentage}%`,
                              backgroundColor: item?.color,
                            }}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
      />
    </div>
  );
}

export default PathwayData;
